var isPrototypeOf = require('../internals/object-is-prototype-of');

var $TypeError = TypeError;

module.exports = function (it, Prototype) {
  if (isPrototypeOf(Prototype, it)) return it;
  throw $TypeError('Incorrect invocation');
};



//////////////////
// WEBPACK FOOTER
// ./~/react-stickynode/~/core-js/internals/an-instance.js
// module id = 426
// module chunks = 0